import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TimezoneDto } from '../../../commonTypes/organization.types';

const useHttpGetAllTimezonesOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [data, setData] = useState<TimezoneDto[]>([]);
    const [isReady, setIsReady] = useState<boolean>(false);

    const getAllTimezones = () => {
        const { exec, abort } = organizationApi.getTimezones({
            onSuccess: res => {
                setData(res.body);
            },
            onError: err => err,
            onFinally: () => {
                setIsReady(true);
            },
        });
        exec();
        return abort;
    };

    useEffect(getAllTimezones, []);

    return { data, isReady };
};

export default useHttpGetAllTimezonesOnMount;
